// Radicacion de solicitudes portal publico pj
export const GTM_CODE_DEV = 'GTM-M973827';
export const GTM_CODE_PROD = 'GTM-T47852Z';

export const PAGEVIEW = {
  siteChannel: {
    path: 'site.channel',
    value: 'HomeBankingPJ',
  },
  developmenttype: {
    path: 'site.developmenttype',
    value: 'Web',
  },
  environment: {
    path: 'site.environment',
    value: null
  },
  useragent: {
    path: 'site.useragent',
    value: null
  },
  permissions: {
    path: 'site.permissions',
    value: 'Off'
  },
  accessibility: {
    path: 'site.accessibility',
    value: 'NotAvailable'
  },
  geolocation: {
    path: 'visitor.geolocation',
    value: 'NotAvailable'
  },

  // Pantallas de Radicacion de solicitudes
  // Pantalla 1
  pv1pageName: {
    path: 'page.name',
    value: 'SeleccionSolicitud'
  },
  pv1pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv1subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv1pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv1pageid: {
    path: 'page.pageid',
    value: 'P1'
  },
  pv1internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv1transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

  // Pantalla 2
  pv2pageName: {
    path: 'page.name',
    value: 'RadicacionSolicitudPaso1'
  },
  pv2pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv2subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv2pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv2pageid: {
    path: 'page.pageid',
    value: null
  },
  pv2internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv2transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null
  },
  pv2transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

  // Pantalla 4
  pv4pageName: {
    path: 'page.name',
    value: 'RadicacionSolicitudPaso2'
  },
  pv4pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv4subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv4pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv4pageid: {
    path: 'page.pageid',
    value: null
  },
  pv4internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv4transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null
  },
  pv4transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

  // Pantalla 5
  pv5pageName: {
    path: 'page.name',
    value: 'RadicacionSolicitudPaso3'
  },
  pv5pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv5subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv5pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv5pageid: {
    path: 'page.pageid',
    value: null
  },
  pv5internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv5transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null
  },
  pv5transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

  // Pantalla 6
  pv6pageName: {
    path: 'page.name',
    value: 'RadicacionSolicitudPaso4'
  },
  pv6pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv6subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv6pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv6pageid: {
    path: 'page.pageid',
    value: null
  },
  pv6internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv6message: {
    path: 'custom.message',
    value: null
  },
  pv6searchTerm: {
    path: 'custom.searchterm',
    value: null
  },
  pv6transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null
  },
  pv6transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null
  },
  pv6transactionTransactionInstitution: {
    path: 'transaction.details.transactioninstitution',
    value: null
  },
  pv6transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

  // Pantalla 7
  pv7pageName: {
    path: 'page.name',
    value: 'ConsultarSolicitud'
  },
  pv7pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv7subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv7pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv7pageid: {
    path: 'page.pageid',
    value: null
  },
  pv7internaltracking: {
    path: 'custom.internaltracking',
    value: null
  },
  pv7transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null
  },
  pv7transactionName: {
    path: 'transaction.name',
    value: 'AutogestionSolicitudes',
  },

};

export const EVENT = {
  customCategory: {
    module: {
      body: 'Body',
      carousel: 'Carousel',
      footer: 'Footer',
      header: 'Header',
      lightbox: 'Lightbox',
      menu: 'Menu'
    },
    type: {
      accordion: 'Accordion',
      arrow: 'Arrow',
      button: 'Button',
      card: 'Card',
      checkbox: 'Checkbox',
      dropdown: 'Dropdown',
      image: 'Image',
      link: 'Link',
      pagination: 'Pagination',
      radio: 'Radio',
      tab: 'Tab',
      textField: 'TextField',
      tooltip: 'Tooltip',
      warning: 'Warning',
      content: 'Content'
    },
    position: {
      bottom: 'Bottom',
      center: 'Center',
      left: 'Left',
      rigt: 'Right',
      top: 'Top'
    }
  },
  customAction: {
    click: 'Click',
    close: 'Close',
    download: 'Download',
    hide: 'Hide',
    open: 'Open',
    print: 'Print',
    scroll: 'Scroll',
    search: 'Search',
    share: 'Share',
    show: 'Show',
    swipeToLeft: 'SwipeToLeft',
    swipeToRigth: 'SwipeToRigth'
  },

  // Pantallas de Radicacion de solicitudes

  // Eventos transversales Salir
  E1customLabel: 'Salir',
  E1setData: {
    E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },
  // Eventos transversales confirmar salida o cancelar
  E2customLabel: 'Abandono | ',
  E2setData: {
    E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },
  // Eventos transversales menu tabs
  E3customLabel: null,
  E3setData: {
    E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  E4customLabel: 'NavegacionMenu | ',
  E4setData: {
    E4transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    E4transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 1
  pv1E1customLabel: 'BancoItauColombia',
  pv1E1setData: {
    pv1E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },
  pv1E2customLabel: 'ItauAssetManagment',
  pv1E2setData: {
    pv1E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },
  pv1E5customLabel: 'Entendido',
  pv1E5setData: {
    pv1E5transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },
  pv1E6customLabel: 'InstruccionesRadicacion',
  pv1E6setData: {
    pv1E6transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
  },

  // Eventos Pantalla 2
  pv2E2customLabel: 'QueSolicitudesPuedesRadicar',
  pv2E2setData: {
    pv2E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv2E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv2E3customLabel: 'ComoRadicarUnaSolicitud',
  pv2E3setData: {
    pv2E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv2E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv2E4customLabel: 'TyC',
  pv2E4setData: {
    pv2E4transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv2E4transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv2E5customLabel: 'Siguiente',
  pv2E5setData: {
    pv2E5transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv2E5transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
    pv2E5transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },
  pv2E7customLabel: 'ConsultarCliente',
  pv2E7setData: {
    pv2E6transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv2E7transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 3
  pv3E1customLabel: 'Siguiente',
  pv3E1setData: {
    pv3E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv3E1transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv3E2customLabel: 'AgregarContacto',
  pv3E2setData: {
    pv3E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv3E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv3E3customLabel: 'Volver',
  pv3E3setData: {
    pv3E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv3E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 4
  pv4E1customLabel: 'SolicitudesQuePuedesRadicar',
  pv4E1setData: {
    pv4E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv4E1transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv4E2customLabel: 'Siguiente',
  pv4E2setData: {
    pv4E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv4E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
    pv4E2transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv4E2clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null
    },
    pv4E2transactionTransactionInstitution: {
      path: 'transaction.details.transactioninstitution',
      value: null
    },
  },
  pv4E3customLabel: 'CargarArchivo',
  pv4E3setData: {
    pv4E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv4E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv4E4customLabel: 'Volver',
  pv4E4setData: {
    pv4E4transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv4E4transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv4E5customLabel: 'ErrorCargaDocumental',
  pv4E5setData: {
    pv4E5transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv4E5transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 5
  pv5E1customLabel: 'EnviarRequerimiento',
  pv5E1setData: {
    pv5E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv5E1transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv5E2customLabel: 'Volver',
  pv5E2setData: {
    pv5E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv5E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv5E3customLabel: 'Enviar',
  pv5E3setData: {
    pv5E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv5E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
    pv5E3transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv5E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null
    },
    pv5E3transactionTransactionInstitution: {
      path: 'transaction.details.transactioninstitution',
      value: null
    },
  },
  pv5E4customLabel: 'Cancelar',
  pv5E4setData: {
    pv5E4transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv5E4transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv5E5customLabel: 'ErrorWarningRadicacion',
  pv5E5setData: {
    pv5E5transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv5E5transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 6
  pv6E1customLabel: 'CrearNuevaSolicitud',
  pv6E1setData: {
    pv6E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv6E1transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv6E2customLabel: 'ConsultarSolicitudes',
  pv6E2setData: {
    pv6E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv6E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv6E3customLabel: 'RadicacionExitosa',
  pv6E3setData: {
    pv6E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv6E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

  // Eventos Pantalla 7
  pv7E1customLabel: 'Buscar',
  pv7E1setData: {
    pv7E1transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv7E1transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
    pv7E1transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },
  pv7E2customLabel: 'ErrorWarningSolicitud',
  pv7E2setData: {
    pv7E2transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv7E2transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv7E3customLabel: 'VerDetalle',
  pv7E3setData: {
    pv7E3transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv7E3transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv7E4customLabel: 'CargarArchivo',
  pv7E4setData: {
    pv7E4transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv7E4transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },
  pv7E5customLabel: 'DocumentoCargadoExitosamente',
  pv7E5setData: {
    pv7E5transactionName: {
      path: 'transaction.name',
      value: 'AutogestionSolicitudes',
    },
    pv7E5transactionProductCategory: {
      path: 'transaction.details.productcategory',
      value: null
    },
  },

};


export const COUNTRY = {
  ar: 'AR',
  cl: 'CL',
  co: 'CO',
  oca: 'OCA',
  py: 'PY',
  uy: 'UY'
};

export const BUSINNESS = {
  pf: 'PF',
  pj: 'PJ',
  un: 'UN'
};

export const ENVIRONMENT = {
  loggeado: 'LG',
  noLoggeado: 'NL'
};

export const CHANNEL = {
  apppn: 'APN',
  superapp: 'SA',
  apptarjetas: 'AT',
  homeBanking: 'HB',
  abreCuentas: 'AC'

};

export const FAMILY = {
  commonArea: 'AreaComun',
  care: 'Atendimento',
  campaigns: 'Campanas',
  accounts: 'Cuentas',
  fidelity: 'Fidelidad',
  investments: 'Inversiones',
  payment: 'Pagamentos',
  loan: 'Prestamo',
  insurance: 'Seguros',
  services: 'Servicios',
  cards: 'Tarjetas',
  transfers: 'Transferencias',
};

export const SUBFAMILY = {
  personalAccidents: 'AccidentesPersonales',
  aguinaldoAdvance: 'AdelantoAguinaldo',
  customs: 'Aduana',
  savingsForecast: 'AhorroPrevisionalUdutario',
  savingsScheduled: 'AhorroProgramado',
  feed: 'Alimentacion',
  proxies: 'Apoderados',
  automotive: 'Automotores',
  help: 'Ayuda',
  banksLocais: 'BancosLocais',
  basic: 'Basica',
  beneficiaries: 'Beneficiarios',
  profitCards: 'BeneficioTarjetas',
  boxSavings: 'CajaAhorro',
  juniorSavingsBox: 'CajaAhorroJunior',
  cashiers: 'Cajeros',
  change: 'Cambio',
  captureDocument: 'CapturaDocumento',
  certification: 'Certificacion',
  chat: 'Chat',
  checks: 'Cheques',
  checksFanfold: 'ChequesFanfold',
  tradeExterior: 'ComercioExterior',
  configurationLinking: 'ConfiguracionVinculacion',
  foreignCurrency: 'CorrienteMonedaExtranjera',
  LocalCurrencyStream: 'CorrienteMonedaLocal',
  credit: 'Credito',
  ownAccounts: 'CuentasPropias',
  virtualAccounts: 'CuentasVirtuales',
  debitoAutomatico: 'DebitoAutomatico',
  depositsTermFixed: 'DepositosPlazoFijo',
  digitization: 'Digitalizacion',
  outside: 'Dxterior',
  bill: 'Factura',
  faq: 'FAQ',
  finance: 'Finanzas',
  fonasa: 'Fonasa',
  funds: 'Fondos',
  form: 'Formulario',
  formInitial: 'FormularioInicial',
  turnsIEDE: 'GirosIEDE',
  datacontact: 'DatosContacto',
  mortgage: 'Hipotecarios',
  historicYTaxasCommissions: 'HistoricoComisionesYTaxas',
  HistoricOfUnderstandings: 'HistoricoDeComprovantes',
  home: 'Home',
  incomedata: 'IngresoDatos',
  irpf: 'IRPF',
  itau: 'Itau',
  landingPage: 'LandingPage',
  letterChange: 'LetraDeCambio',
  letterOfRegulation: 'LetrasDeRegulacionMonetaria',
  linkChannelYoutube: 'LinkCanalYoutube',
  limit: 'Limite',
  creditline: 'LineaDeCredito',
  login: 'Login',
  movements: 'Movimientos',
  notification: 'Notificacion',
  offerProducts: 'OfertaProductos',
  paymentsSMS: 'PagosSMS',
  shareholdingInCertificateOfDeposit: 'ParticipacionEnCertificadoDeDeposito',
  finalStep: 'PasoFinal',
  riskProfile: 'PerfilDeRiesgo',
  personal: 'Personales',
  pld: 'PLD',
  preapproved: 'Preaprobado',
  products: 'Productos',
  proposta: 'Proposta',
  promotions: 'Promociones',
  points: 'Puntos',
  recharge: 'Recarga',
  rechargeable: 'Recargable',
  fundraising: 'Recaudadoras',
  registration: 'Registro',
  health: 'Salud',
  security: 'Seguridad',
  self: 'Self',
  services: 'Servicios',
  overdraft: 'Sobregiro',
  request: 'Solicitud',
  surcursales: 'Surcursales',
  tariff: 'Tarifario',
  cards: 'Tarjetas',
  card: 'TarjetaDebito',
  tolls: 'Telepeaje',
  typechange: 'TipoCambio',
  titleWithSectiones: 'TituloConsecciones',
  travel: 'Viajes',
  life: 'Vida',
  view: 'Vista',
  wallet: 'Wallet',
};

export const PRODUCT = {
  open: 'Abrir',
  activate: 'Activar',
  add: 'Agregar',
  schedule: 'Agendar',
  block: 'Bloquear ',
  change: 'Cambiar',
  cancel: 'Cancelar',
  redeem: 'Canjear',
  consult: 'Consultar',
  configure: 'Configurar',
  hire: 'Contratar',
  disable: 'Desabilitar',
  address: 'Direccionar',
  edit: 'Editar',
  remove: 'Eliminar',
  enable: 'Habilitar',
  log: 'Loguear',
  pay: 'Pagar',
  rescue: 'Rescatar',
  recharge: 'Recargar',
  request: 'Solicitar',
  offer: 'Ofertar',
  transfe: 'Transferir',
};